import React from 'react';
import { Toggle } from '@bucketplace/commerce-admin-ui';

import { DurationInputField, FieldItem, FormContent, InspectorFormProvider } from '../../../components';
import { ImageField } from '../../../components/Input/ImageField';
import { DocumentInspectorProps } from '../../../types';
import { convertDurationFormat } from '../../../utils';
import { LottieProps } from '../Lottie';
import { LottieUploadField } from './LottieUploadField';

export function LottieInspector({
  value: inspectorValue,
  onChange,
}: DocumentInspectorProps<LottieProps>) {
  const convertedDuration = convertDurationFormat(inspectorValue.props.duration);
  const formValue = {
    ...inspectorValue,
    props: {
      ...inspectorValue.props,
      duration: convertedDuration,
    },
  };

  const handleToogleDuration = (value: boolean) => {
    const { duration, ...rest } = inspectorValue.props;

    onChange({
      ...inspectorValue,
      props: {
        ...rest,
        ...value && {
          duration: {},
        },
      },
    });
  };

  const { duration } = inspectorValue.props;

  return (
    <InspectorFormProvider value={formValue} onChange={onChange}>
      <FormContent header="썸네일" required direction="VERTICAL">
        <FieldItem error hint="* 썸네일은 Lottie파일과 크기가 동일해야합니다.">
          <ImageField name="thumbnail" />
        </FieldItem>
      </FormContent>
      <FormContent header="이미지" required direction="VERTICAL">
        <LottieUploadField
          name="src"
        />
      </FormContent>
      <FormContent header="노출시간 설정">
        <Toggle checked={!!duration} onCheck={handleToogleDuration} />
      </FormContent>
      {
        duration && (
          <FormContent>
            <DurationInputField name="duration" />
          </FormContent>
        )
      }
    </InspectorFormProvider>
  );
}
